import React from "react"
import styles from "../form.module.css"
import { safeMoment } from "../../../utils/utils"
import Week from "./Week"

const Month = ({ month, handleSelectDates }) => {
    const monthString = safeMoment(month.firstDayOfMonth).format("MMMM")
    const yearString = safeMoment(month.firstDayOfMonth).format("YYYY")

    const getWeekDays = () => (
        <>
            <span>Dom</span>
            <span>Seg</span>
            <span>Ter</span>
            <span>Qua</span>
            <span>Qui</span>
            <span>Sex</span>
            <span>Sáb</span>
        </>
    )

    return (
        <div className={styles.month}>
            <div className={styles.header}>
                <span><strong>{monthString} de</strong> {yearString}</span>
                <div className={styles.weekDays}>
                    {getWeekDays()}
                </div>
            </div>
            {month.days.map((week, index) => (
                <Week week={week} key={index} handleSelectDates={handleSelectDates} />
            ))}
        </div>
    )
}

export default Month